import React from "react";

export default function EmployeesArea(props) {
  const { image, name, position, job, email, phone, description } = props;
  const isSkeleton = typeof image === 'object' || typeof name === 'object';
  const photo = !isSkeleton && image ? String(image) : '';
  const mail = !isSkeleton && email ? String(email).trim() : '';
  const tel = !isSkeleton && phone ? String(phone).trim() : '';

  return (
    <article className={`spg-person${isSkeleton ? ' is-loading' : ''}`}>
      <div className={`spg-person-photo${photo ? '' : ' is-empty'}`}>
        {isSkeleton ? image : photo ? (
          <img src={photo} alt={typeof name === 'string' ? name : ''} />
        ) : null}
      </div>
      <div className="spg-person-body">
        {position ? <span className="spg-person-role">{position}</span> : null}
        <h3>{name}</h3>
        {job ? <p className="spg-person-job">{job}</p> : null}
        {description ? <p className="spg-person-text">{description}</p> : null}
        {(mail || tel) ? (
          <div className="spg-person-links">
            {mail ? <a href={`mailto:${mail}`}>{mail}</a> : null}
            {tel ? <a href={`tel:${tel}`}>{tel}</a> : null}
          </div>
        ) : null}
      </div>
    </article>
  );
}
